import React from 'react'

import { LoadingButton as MuiLoadingButton } from '@mui/lab'
import { SxProps } from '@mui/system'
import { ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  loading?: boolean
  variant?: 'text' | 'outlined' | 'contained' | undefined
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
  disabled?: boolean
  sx?:SxProps
}

const LoadingButton:ReactFC<Props> = ({
  children,
  loading,
  variant,
  onClick,
  disabled,
  sx,
  ...buttonProps
}) => {
  return (
    <MuiLoadingButton
      disabled={disabled}
      loading={loading}
      variant={variant}
      onClick={onClick}
      sx={sx}
      {...buttonProps}
    >
      {children}
    </MuiLoadingButton>
  )
}
export default LoadingButton
